import { makeGetRequest } from "./makeGetRequest";

interface IProps {
  authToken: string | null;
  signal?: AbortSignal;
}

export async function fetchSyncHttpStripeSetupIntent({ authToken, signal }: IProps): Promise<{ clientSecret: string }> {
  const resp = await makeGetRequest({
    requestName: "fetchSyncHttpStripeSetupIntent",
    authToken,
    path: `/api/v1/subscription/stripe/setup_intent`,
    signal,
  });

  return (await resp.json()) as { clientSecret: string };
}
